URL = '/keepcon/settings/user_profile_attributes'
class AccountSettings.UserProfileAttribute extends Backbone.Model
  urlRoot: URL

  defaults: ->
    {
      multiple: true,
      advise_for_merge: false
    }

  save: (attrs, options) ->
    attrs ||= _.clone(this.attributes)
    options ||= {}
    data = {'keepcon_settings_user_profile_attribute' : attrs}
    super data, options

class AccountSettings.UserProfileAttributeCollection extends Backbone.Collection
  model: AccountSettings.UserProfileAttribute
  url: URL

  parse: (response) ->
    @availableTypes = response.available_types
    @readonlyFields = response.readonly_fields
    super(response.user_profile_attributes)

  updatePositions: (originalPosition, newPosition) ->
    return this if originalPosition == newPosition
    temp = @at(originalPosition)
    @remove(temp, { silent: true })
    @add(temp, { at: newPosition, silent: true })
    return Backbone.ajax({
      url: @url + '/sort',
      method: 'POST',
      data: { ids: @pluck('id') },
      dataType: "json",
    });
